var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { EditorState, Modifier } from 'draft-js';
var LinkOption = /** @class */ (function (_super) {
    __extends(LinkOption, _super);
    function LinkOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LinkOption.prototype, "addLink", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a = this.props, editorState = _a.editorState, onChange = _a.onChange;
            var contentState = Modifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '{link}', editorState.getCurrentInlineStyle());
            onChange(EditorState.push(editorState, contentState, 'insert-characters'));
        }
    });
    Object.defineProperty(LinkOption.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs("div", __assign({ onClick: function () { return _this.addLink(); } }, { children: [_jsx("img", { src: "/Content/Images/Logo-small.png", alt: "logo" }, void 0), "Insert Link"] }), void 0));
        }
    });
    return LinkOption;
}(React.Component));
export { LinkOption };
